import { Identifier, randomUUID } from "../id";
export class PModifierInstanceId extends Identifier {
    constructor() {
        super("PModifierInstanceId", randomUUID());
    }
}
